import DeleteIcon from "../Icons/DeleteIcon";
import HeaderIcon from "../Icons/Header";
import PencilIcon from "../Icons/Pencil";
import {
	deleteDiaryPost,
	deletePost,
	getDailyPosts,
	getDateTimeFromISOString,
	getDiaryPosts,
} from "./CommonFunc";
import { daysArray } from "./Constans";
import "./Diary.scss";
import EmptyDiary from "./EmptyDiary";
import { useEffect, useRef, useState } from "react";

export default function Diary(props) {
	if (props.currentDiaryPosts.length === 0 && props.currentDiary?.ID) {
		return <EmptyDiary />;
	} else {
		return (
			<>
				{props.currentDiaryPosts?.map((item, i) => (
					<>
						<Post
							key={i}
							selectedPost={props.selectedPost}
							setSelectedPost={props.setSelectedPost}
							post={item}
							index={i}
							setOpenEditPost={props.setOpenEditPost}
							currentDiaryPosts={props.currentDiaryPosts}
							currentDiary={props.currentDiary}
							setCurrentDiaryPosts={props.setCurrentDiaryPosts}
							contentRef={props.contentRef}
						/>
						<hr></hr>
					</>
				))}
			</>
		);
	}
}

function Post({
	selectedPost,
	post,
	index,
	setSelectedPost,
	setOpenEditPost,
	currentDiaryPosts,
	currentDiary,
	setCurrentDiaryPosts,
	contentRef,
}) {
	const [text, setText] = useState("");
	const postRef = useRef();
	const selection = (i) => {
		if (selectedPost === i) {
			setSelectedPost(null);
		} else {
			setSelectedPost(i);
		}
	};
	const handleDeletePost = () => {
		deletePost(currentDiaryPosts[index].ID_NOTE).then(() =>
			getDailyPosts(currentDiary.ID, 0, 10).then((posts) => {
				setCurrentDiaryPosts(posts);
				setSelectedPost(null);
			})
		);
	};
	const [date, time] = [post.DATE_EDIT, post.TIME_EDIT];
	const dateArray = date.split(".");
	const normalDate = `${dateArray[1]}.${dateArray[0]}.${dateArray[2]}`;
	const dayIndex = new Date(normalDate).getDay();
	const dayLabel = daysArray[dayIndex];
	useEffect(() => {
		if (new Date(normalDate).getTime() > new Date().getTime()) {
			postRef.current.scrollIntoView();
		}
	}, []);
	function convertToPlain(rtf) {
		rtf = rtf.replace(/\\par[d]?/g, "");
		return rtf
			.replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, "")
			.trim();
	}
	const creatLinks = (text) => {
		return text.replace(/(http).*$/gim, (match) => {
			return `<a href="${match}" class="link" title=${match} target="_blank">${match.slice(
				0,
				30
			)}...</a>`;
		});
	};
	return (
		<div
			ref={postRef}
			key={index}
			className={`post ${selectedPost === index ? "selected" : ""}`}
			onClick={() => selection(index)}
		>
			<div className='header-wrapper'>
				<div className='misc'>
					{/* <div className='context-actions'>
						<PencilIcon
							width={24}
							height={24}
							tooltip={"Редактировать"}
							func={() => {
								selection(index);
								setOpenEditPost(true);
							}}
						/>
						<DeleteIcon
							width={24}
							height={24}
							tooltip={"Удалить"}
							func={handleDeletePost}
						/>
					</div> */}
					<div className='dateTime'>
						<div className='date'>{date}</div>
						<div className='day' title={time}>
							{dayLabel}
						</div>
					</div>
				</div>
				{post.MNEMO ? <div className='post-header'>{post.MNEMO}</div> : null}
			</div>
			<div
				style={{ whiteSpace: "pre-wrap" }}
				// dangerouslySetInnerHTML={{ __html: post.CONT_TXT }}
				dangerouslySetInnerHTML={{ __html: creatLinks(post.CONT_TXT) }}
			></div>
		</div>
	);
}
